/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const travel_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15.504 5.7 3.399-1.714c1.384-.686 3.129-.09 3.81 1.277.688 1.38.09 3.12-1.28 3.8l-3.564 1.762-1.937 8.095a1.149 1.149 0 0 1-.6.753l-1.949.964c-.74.368-1.636-.211-1.625-1.019v-5.77l-3.75 1.86a2.317 2.317 0 0 1-2.485-.31l-4.138-3.512c-.608-.52-.47-1.528.232-1.878l2.175-.956 2.03 1.527 4.605-2.322M15.504 5.7 10.89 3.368a1.156 1.156 0 0 0-1.017 0l-1.915.943c-.741.37-.825 1.43-.179 1.92l2.65 2.026M15.503 5.7l-5.077 2.558"
    />
  </svg>
)
export default travel_medium
